import { useEventListener } from './use-event-listener.js';

/**
 * Custom hook for handling clicks outside a specified element.
 * @template T - The type of the element's reference.
 * @param {RefObject<T> | RefObject<T>[]} ref - The React ref object(s) representing the element(s) to watch for outside clicks.
 * @param {(event: MouseEvent | TouchEvent) => void} handler - The callback function to be executed when a click outside the element occurs.
 * @param {EventType} [eventType] - The mouse event type to listen for (optional, default is 'mousedown').
 * @returns {void}
 * @see [Documentation](https://usehooks-ts.com/react-hook/use-on-click-outside)
 * @example
 * const containerRef = useRef(null);
 * useOnClickOutside([containerRef], () => {
 *   // Handle clicks outside the container.
 * });
 */
function useOnClickOutside(ref, handler, eventType) {
  if (eventType === void 0) {
    eventType = "mousedown";
  }
  useEventListener(eventType, function (event) {
    var target = event.target;
    // Do nothing if the target is not connected element with document
    if (!target || !target.isConnected) {
      return;
    }
    var isOutside = Array.isArray(ref) ? ref.every(function (r) {
      return r.current && !r.current.contains(target);
    }) : ref.current && !ref.current.contains(target);
    if (isOutside) {
      handler(event);
    }
  });
}

export { useOnClickOutside };
//# sourceMappingURL=use-on-click-outside.js.map
